import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';

export async function getRelatedUser(mobile: any) {
    return axiosWithAuthInterceptor.get(
        `${process.env.REACT_APP_LIMOOME_SERVER}/lemonade-admin/related-users?mobile=${mobile}`).then(res => {
            return res
        })

}


export async function transferUserData(param: any) {
    return axiosWithAuthInterceptor.post(
        `${process.env.REACT_APP_LIMOOME_SERVER}/lemonade-admin/transfer-user-data`, param).then(res => {
            return res
        })
}


export async function archiveUserData(param: any) {
    return axiosWithAuthInterceptor.post(
        `${process.env.REACT_APP_LIMOOME_SERVER}/lemonade-admin/archive-user-data`, param).then(res => {
            return res
        })
}

export async function editDietInfo(param: any) {

    return axiosWithAuthInterceptor.post(
        `${process.env.REACT_APP_LIMOOME_SERVER}/lemonade-admin/edit-user-data`, param).then(res => {
            return res
        })
}
export async function deleteSibNumber(param: any) {

    return axiosWithAuthInterceptor.post(
        `${process.env.REACT_APP_LIMOOME_SERVER}/lemonade-admin/delete-sib-profile-number`, { customerId: param }).then(res => {
            return res
        })
}
